import { Link } from "react-router-dom";
import {
  Building2,
  FileText,
  Calculator,
  Search,
  Phone,
  Shield,
  FileText2,
  ChevronDown,
  DollarSign,
} from "lucide-react";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuList,
  NavigationMenuTrigger,
  NavigationMenuLink,
  navigationMenuTriggerStyle,
} from "@/components/ui/navigation-menu";

export const MainNavigationMenu = () => {
  return (
    <NavigationMenu>
      <NavigationMenuList>
        <NavigationMenuItem>
          <NavigationMenuTrigger className={navigationMenuTriggerStyle()}>
            <Building2 className="w-4 h-4 mr-2" />
            Business Registration
          </NavigationMenuTrigger>
          <NavigationMenuContent>
            <div className="grid gap-3 p-6 md:w-[400px] lg:w-[500px] lg:grid-cols-2">
              <Link
                to="/abn-registration"
                className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
              >
                <div className="flex items-center gap-2 mb-1">
                  <FileText className="h-4 w-4 text-primary" />
                  <div className="text-sm font-medium leading-none">
                    ABN Registration
                  </div>
                </div>
                <p className="line-clamp-2 text-sm leading-snug text-muted-foreground">
                  Register your Australian Business Number quickly and easily.
                </p>
              </Link>
              <Link
                to="/gst-registration"
                className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
              >
                <div className="flex items-center gap-2 mb-1">
                  <FileText className="h-4 w-4 text-primary" />
                  <div className="text-sm font-medium leading-none">
                    GST Registration
                  </div>
                </div>
                <p className="line-clamp-2 text-sm leading-snug text-muted-foreground">
                  Register for Goods and Services Tax with the ATO.
                </p>
              </Link>
              <Link
                to="/acn-registration"
                className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
              >
                <div className="flex items-center gap-2 mb-1">
                  <FileText className="h-4 w-4 text-primary" />
                  <div className="text-sm font-medium leading-none">
                    ACN Registration
                  </div>
                </div>
                <p className="line-clamp-2 text-sm leading-snug text-muted-foreground">
                  Register your Australian Company Number.
                </p>
              </Link>
              <Link
                to="/company-registration"
                className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
              >
                <div className="flex items-center gap-2 mb-1">
                  <Building2 className="h-4 w-4 text-primary" />
                  <div className="text-sm font-medium leading-none">
                    Company Registration
                  </div>
                </div>
                <p className="line-clamp-2 text-sm leading-snug text-muted-foreground">
                  Complete company registration services.
                </p>
              </Link>
            </div>
          </NavigationMenuContent>
        </NavigationMenuItem>

        <NavigationMenuItem>
          <NavigationMenuTrigger className={navigationMenuTriggerStyle()}>
            <Calculator className="w-4 h-4 mr-2" />
            Tools
          </NavigationMenuTrigger>
          <NavigationMenuContent>
            <div className="grid gap-3 p-6 md:w-[400px] lg:w-[500px]">
              <Link
                to="/abn-lookup"
                className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
              >
                <div className="flex items-center gap-2 mb-1">
                  <Search className="h-4 w-4 text-primary" />
                  <div className="text-sm font-medium leading-none">
                    ABN Lookup
                  </div>
                </div>
                <p className="line-clamp-2 text-sm leading-snug text-muted-foreground">
                  Search and verify Australian Business Numbers.
                </p>
              </Link>
              <Link
                to="/calculators"
                className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
              >
                <div className="flex items-center gap-2 mb-1">
                  <Calculator className="h-4 w-4 text-primary" />
                  <div className="text-sm font-medium leading-none">
                    Financial Calculators
                  </div>
                </div>
                <p className="line-clamp-2 text-sm leading-snug text-muted-foreground">
                  Tools to help with financial planning and calculations.
                </p>
              </Link>
            </div>
          </NavigationMenuContent>
        </NavigationMenuItem>

        <NavigationMenuItem>
          <Link to="/tax-information" className={navigationMenuTriggerStyle()}>
            <DollarSign className="w-4 h-4 mr-2" />
            Tax Information
          </Link>
        </NavigationMenuItem>

        <NavigationMenuItem>
          <Link to="/contact" className={navigationMenuTriggerStyle()}>
            <Phone className="w-4 h-4 mr-2" />
            Contact
          </Link>
        </NavigationMenuItem>

        <NavigationMenuItem>
          <NavigationMenuTrigger className={navigationMenuTriggerStyle()}>
            <Shield className="w-4 h-4 mr-2" />
            Legal
          </NavigationMenuTrigger>
          <NavigationMenuContent>
            <div className="grid gap-3 p-6 md:w-[400px]">
              <Link
                to="/privacy"
                className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
              >
                <div className="flex items-center gap-2 mb-1">
                  <Shield className="h-4 w-4 text-primary" />
                  <div className="text-sm font-medium leading-none">
                    Privacy Policy
                  </div>
                </div>
                <p className="line-clamp-2 text-sm leading-snug text-muted-foreground">
                  Our privacy policy and data protection practices.
                </p>
              </Link>
              <Link
                to="/terms"
                className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
              >
                <div className="flex items-center gap-2 mb-1">
                  <FileText className="h-4 w-4 text-primary" />
                  <div className="text-sm font-medium leading-none">
                    Terms of Service
                  </div>
                </div>
                <p className="line-clamp-2 text-sm leading-snug text-muted-foreground">
                  Terms and conditions for using our services.
                </p>
              </Link>
            </div>
          </NavigationMenuContent>
        </NavigationMenuItem>
      </NavigationMenuList>
    </NavigationMenu>
  );
};
